import { Box, Stack, StickerLabel, StickerLabelVariant } from '@stitch-fix/mode-react';
import classNames from 'classnames';
import type { ContentStackJSONRichText } from '../../utils/requests/contentstack/contentStackZodSchema';
import { CloudinaryImageWrapper, type CloudinaryImageFields } from '../CloudinaryImageWrapper';
import { JsonRteRenderer } from '../JsonRteRenderer';
import { ModularComponentProps } from '../ModularPageWrapper/ModularPageWrapper';
import styles from './styles.module.scss';
export type Theme = {
  backgroundColor: 'mint-60' | 'blue-45' | 'gray-99' | 'citrus-60' | 'forest-60' | 'grapefruit-60' | 'cerulean-60' | 'white';
  textColor: 'mint-60' | 'blue-45' | 'forest-60' | 'white' | 'citrus-60';
};
export type DisplaySplitProps = {
  text: ContentStackJSONRichText;
  media: CloudinaryImageFields;
  backgroundColor: Theme['backgroundColor'];
  textColor: Theme['textColor'];
  contentOrder?: 'textFirst' | 'mediaFirst';
  desktopContentOrder?: 'textFirst' | 'mediaFirst';
  stickerLabel?: string;
  stickerLabelVariant?: StickerLabelVariant;
  CTAButton?: React.ReactNode;
  alignContent?: 'left' | 'center';
};
export const DisplaySplit = ({
  text,
  media,
  backgroundColor,
  textColor,
  contentOrder = 'mediaFirst',
  desktopContentOrder = 'mediaFirst',
  stickerLabel = '',
  stickerLabelVariant = 'citrus',
  verticalSpacing,
  CTAButton,
  alignContent = 'left'
}: DisplaySplitProps & ModularComponentProps) => {
  return <Box bgColor={backgroundColor} mt={verticalSpacing}>
      <Box className={styles.container} data-testid="display-split-container">
        <Box className={styles.media}>
          <CloudinaryImageWrapper alt={media.alt} src={media.src} sources={{
          sm: 377,
          md: 500,
          lg: 650
        }} imageProps={{
          loading: 'lazy'
        }} />
        </Box>
        <Box className={classNames(styles.text, {
        [styles.textFirst]: contentOrder === 'textFirst',
        [styles.desktopTextFirst]: desktopContentOrder === 'textFirst'
      })}>
          <Stack spacing={1.5} hAlign={alignContent === 'center' ? 'center' : 'start'}>
            {stickerLabel && <StickerLabel variant={stickerLabelVariant}>
                {stickerLabel}
              </StickerLabel>}
            <JsonRteRenderer data={text} options={{
            textSizeMap: 'display',
            color: textColor,
            textProps: {
              p: {
                align: alignContent === 'center' ? 'center' : 'left',
                setting: 'body-large'
              }
            }
          }} />
            {CTAButton}
          </Stack>
        </Box>
      </Box>
    </Box>;
};